import { Button, CircularProgress } from "@material-ui/core";
import React from "react";

export default function CustomButton(props) {
  const { btnProps, type, isLoading = false, ...restProps } = props;
  return (
    <Button
      type={type}
      {...btnProps}
      {...restProps}
      disabled={isLoading || restProps.disabled}
    >
      {isLoading ? <CircularProgress size={20} color="inherit" /> : btnProps?.text}
    </Button>
  );
}
